import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import '../../scss/brand.scss';
import CustomRangeInput from '../../../../shared-components/custom-range-input/custom-range-input';
import CustomSwitchButton from '../../../../shared-components/custom-switch-button/custom-switch-button';

interface BrandProperties {
  qrValues: any;
  setQrValues: React.Dispatch<React.SetStateAction<any>>;
}

/**
 * QR Brand Component
 * @param {BrandProperties} properties - Component properties
 * @param {any} properties.qrValues - The qrValues prop
 * @param {React.Dispatch<React.SetStateAction<any>>} properties.setQrValues - The setQrValues prop
 * @returns {JSX.Element} The Brand component layout
 */
function Brand({ qrValues, setQrValues }: BrandProperties): JSX.Element {
  const { t } = useTranslation('qrCode');
  const [checkedTrue, setCheckedTrue] = useState<boolean>(false);

  const logoProperties = [
    {
      id: 1,
      name: 'logoWidth',
      value: qrValues.logoWidth,
      label: t('logoSize'),
      min: 50,
      max: 150,
      valueType: 'Px',
    },
    {
      id: 2,
      name: 'logoTrans',
      value: qrValues.logoTrans,
      label: t('logoTranspatency'),
      min: 0.0,
      max: 1.0,
      step: 0.1,
      valueType: '%',
    },
  ];

  /**
   * Handling Range Values
   * @param {string} name - Property name
   * @param {string | number} value - Property value
   */
  const handleValue = (name: string, value: string | number) => {
    setQrValues((previous: any) => ({
      ...previous,
      [name]: value,
    }));
  };

  /**
   * Handling Switch Enabling
   */
  const handleSwitch = () => {
    setCheckedTrue((previous) => !previous);
  };

  return (
    <div className="brand">
      <div className="brand-logo">
        {logoProperties.map((Property) => (
          <CustomRangeInput
            key={Property.id}
            label={Property.label}
            name={Property.name}
            value={Property.value}
            valueType={Property.valueType}
            onChange={handleValue}
            min={Property.min}
            max={Property.max}
            step={Property.step}
          />
        ))}
      </div>
      <div className="brand-logo-bg">
        <div>
          <p className="switch-button">{t('backgroundColor')} </p>
          <CustomSwitchButton checked={checkedTrue} change={handleSwitch} />
        </div>
        <input type="color" />
      </div>
    </div>
  );
}

export default Brand;
